<template>
  <div v-if="inputedValue.dialog && pageData.length > 0">
    <InfoDialogBase
      v-model="inputedValue"
      :width="width"
      :title="title"
      :pageData="pageData"
      :recItems="recItems"
      :isFooter="true"
      :isTotalAmount="false"
      @editRemarks="editRemarks"
      :isEdit="isEdit"
    >
      <template #footer>
        <TotalAmount v-model="registerData.totalList" />
        <NormalButton
          :text="$t('common.input_fix')"
          color="white"
          class="pr-5"
          textColor="thinText--text"
          height="50px"
          width="130px"
          @click="inputedValue.dialog = false"
        />
        <NormalButton
          :text="$t('common.input_save')"
          height="50px"
          width="130px"
          :loading="isBtnLoading"
          @click="isEdit ? edit() : register()"
        />
        <DialogAlertSuccess
          v-model="completeDialog"
          :text="$t('common.common_register-complete')"
        />
      </template>
    </InfoDialogBase>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

import InfoDialogBase from './OrderInfoDialogBase'
import TotalAmount from '@/components/items/Designs/TotalAmount/TotalAmount'
import NormalButton from '@/components/items/Buttons/NormalButton'
import DialogAlertSuccess from '@/components/layouts/Dialogs/DialogAlert/DialogAlertSuccess'

import headers from '@/views/order/History/headers'

export default {
  components: {
    InfoDialogBase,
    TotalAmount,
    NormalButton,
    DialogAlertSuccess
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    isEdit: { default: false },
    orderId: { default: undefined },
    registerData: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  data: () => ({
    recItems: {},
    pageData: [],
    completeDialog: false,
    isBtnLoading: false,
    remarks: {
      private: '',
      client: ''
    },
    orderEditHistoryList: []
  }),
  created() {
    // this.init()
  },
  methods: {
    ...mapActions('Order', [
      'registerOrder',
      'editOrder',
      'getOrderDetailListFromApi'
    ]),
    ...mapActions('Common', ['setIsLoading']),
    async init() {
      if (this.inputedValue.dialog) {
        const productMovesTmp = this.registerData.product.data.map(
          (ele, index) => {
            return {
              productMoveId: index,
              price: ele.price,
              quantity: ele.count,
              currencyId: ele.currencyId,
              exportSubjectFlg: ele.exportSubjectFlg,
              product: ele
            }
          }
        )

        this.recItems = {
          productMoves: productMovesTmp,
          client: this.registerData.client,
          totalList: this.registerData.totalList
        }
      }

      this.pageData = [
        {
          title: 'order.order_supplier-info',
          name: 'spplierInfo',
          items: [],
          itemKey: ''
        },
        {
          title: 'order.order_order-detail',
          name: 'orderDetail',
          headers: headers.productListHeaders,
          items: [],
          footers: [],
          itemKey: Object.keys(this.recItems).length
            ? this.recItems.orderId
            : ''
        }
      ]
      if (!this.isEdit) {
        this.pageData.push({
          title: 'sale.sale_note',
          name: 'test1',
          items: [],
          itemKey: ''
        })
      } else {
        const orderDetailList = await this.getOrderDetailListFromApi({
          orderIds: this.orderId
        })
        this.orderEditHistoryList = orderDetailList.data[0].orderEditHistoryList
      }
    },
    async register() {
      this.setIsLoading(true)
      this.isBtnLoading = true
      const isSuccess = await this.registerOrder(this.request)
      if (isSuccess) {
        this.completeDialog = true
      }
      this.isBtnLoading = false
      this.setIsLoading(false)
    },
    async edit() {
      const params = this.request
      let beforeOrderEditHistoryId = null
      this.orderEditHistoryList.forEach((history) => {
        if (beforeOrderEditHistoryId === null) {
          beforeOrderEditHistoryId = history.orderEditHistoryId
        } else if (beforeOrderEditHistoryId < history.orderEditHistoryId) {
          beforeOrderEditHistoryId = history.orderEditHistoryId
        }
      })
      params.beforeOrderEditHistoryId = beforeOrderEditHistoryId
      this.setIsLoading(true)
      this.isBtnLoading = true
      const isSuccess = await this.editOrder(params)
      if (isSuccess) {
        this.completeDialog = true
      }
      this.isBtnLoading = false
      this.setIsLoading(false)
    },
    editRemarks(...args) {
      const [remarks] = args
      this.remarks = {
        private: remarks.private,
        client: remarks.client
      }
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    request() {
      return {
        id: this.orderId,
        clientData: this.registerData.client,
        registerProductList: this.registerData.product.data,
        totalList: this.registerData.totalList,
        privateRemarks: this.remarks.private,
        clientRemarks: this.remarks.client
      }
    }
  },
  watch: {
    inputedValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.dialog) this.init()
      }
    },
    completeDialog: function (newVal, oldVal) {
      if (!newVal && oldVal) {
        this.$router.push({ name: 'order.history' })
        this.inputedValue.dialog = false
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
